import React, {useState} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function AlertDeleteDialog(props) {

  return (
    <React.Fragment>
      <Dialog
        open={props.open}
        onClose={props.close}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'Confirmation'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" className='alert-description'>
            {`Are you sure you want to delete this ${props.deleteAction}? ${props.deleteAction} & its content will be PERMANENTLY DELETED.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" autoFocus onClick={props.deleteAction === 'report' ? props.deleteReport : props.deleteFolder}>YES</Button>
          <Button variant="outlined" color="primary" onClick={props.close} >
            NO
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}